<template>
  <aside
    class="is-unselectable column is-2 is-narrow-mobile is-fullheight section"
  >
    <ul class="menu-list">
      <li>
        <span class="icon">
          <i class="fa fa-desktop"></i>
        </span>
        Extra computers
        <ul>
          <li>
            <router-link to="/subscriptions/computers"
              >Subscriptions</router-link
            >
          </li>
          <li>
            <router-link to="/servers" exact
              >Assign subscription to server</router-link
            >
          </li>
        </ul>
      </li>
      <li>
        <span class="icon">
          <i class="fa fa-server"></i>
        </span>
        Deployify SaaS/VPS
        <ul class="menu-list">
          <li>
            <router-link to="/subscriptions/vps/">Manage</router-link>
          </li>
        </ul>
      </li>

      <li>
        <span class="icon">
          <i class="fa fa-file-invoice-dollar"></i>
        </span>
        Invoicing
        <ul class="menu-list">
          <li>
            <router-link to="/invoicing">Invoices & receipts</router-link>
          </li>
        </ul>
      </li>

      <li>
        <span class="icon">
          <i class="fa fa-question-circle"></i>
        </span>
        Help
        <ul class="menu-list">
          <li>
            <router-link to="/instructions">Instructions</router-link>
          </li>
        </ul>
      </li>

      <li>
        <span class="icon">
          <i class="fa fa-cogs"></i>
        </span>
        Settings
        <ul class="menu-list">
          <li>
            <Billing v-if="billing" :billing="billing" @saved="ReloadPage()"
              >Billing information</Billing
            >
          </li>
        </ul>
      </li>
    </ul>
  </aside>
</template>

<script>
import Billing from "@/components/main/user/billing/component.vue";

export default {
  components: { Billing },
  data() {
    return {
      billing: null,
    };
  },
  created() {
    this.GetBilling();
  },
  methods: {
    ReloadPage() {
      setTimeout(() => {
        location.reload();
      }, 3000);
    },
    async GetBilling() {
      let result = await this.$helpers.PostApi("get/userBilling");
      this.billing = result[0];
    },
  },
};
</script>
